import styled from 'styled-components'

const TableWrapper = styled.div`
    border-radius: 15px;
    border: solid 1px #87cdf1;
    overflow: hidden;
    margin-bottom: 0px;
    box-shadow: 0 9px 8px 0 rgb(0 0 0 / 16%);
    .sender-initial{
        width: 25px;
        height: 23px;
        border-radius: 50%;
        display: inline-flex;
        justify-content: center;
        align-items: center;
        font-weight: bold;
        font-size: 13px;
        margin: 0 4px;
    }

    .sender-initial-buyer{
        background-color: #0a5587;
        color: #fff;

    }

    .sender-initial-seller{
        background-color: #69BBE0;
        color:#000;
    }
`

const Heading = styled.div`
   display: flex;
   align-items: center;
   background-color: #87CDF1;
   padding: 11px 10px 6px 16px;
   min-height: 66px;
   flex-wrap: wrap;
    gap: 10px;
    h3 {
        font-size: 20px;
    color: #000;
    font-family: 'latosemibold';
    flex-grow: 1;
    }
    img{
        cursor: pointer;
        min-width: 25px;
    }
    justify-content: space-between;
`

const SearchWrapper = styled.div`
    display: flex;
    position: relative;
    border-radius: 4.2px;
    overflow: auto;
    width: 100%;
    margin: 0px 0px 30px 0px;
    input {
        background: #ffffff;
    border: none;
    padding: 4px 35px 4px 15px;
    width: 100%;
    ::-webkit-input-placeholder { /* Edge */
    color: #00000087;
}
`
const NameSection = styled.div`
    margin: 10px;
    display: flex;
    flex-wrap: wrap;
    cursor: pointer;
    padding: 0px 40px 0px 21px;
    div{
        flex: 1 1 230px;
        h6{
            font-size:14px;
        }
        span{
            font-size:14px;
            font-weight: bold;
        }
        img{
            margin-left: 25px;
            height: 17px;
            width: 18px;
        }
    }
`
const NameHeading = styled.div`
    margin: 14px;
    display: flex;
    justify-content: space-between;
    padding:15px;
    div{
        h6{
            margin: 1px 0px 0px 12px;
        }
        img {
            width: 39px;
            height: 45px;
        }
    }
`

export { TableWrapper, Heading, SearchWrapper, NameSection, NameHeading }